import { useRef } from "react";
import { useLatest } from "./useLatest.js";
function useEvent(event) {
  const eventRef = useLatest(event);
  const callback =
  /** @type {any} */
  (...args) => {
    var _a;
    return (_a = eventRef.current) == null ? void 0 : _a.call(eventRef, ...args);
  };

  return useRef(callback).current;
}
export {
  useEvent };
//# sourceMappingURL=dist/lib/hooks/useEvent.js.map